import React, { Component } from 'react'
import LoadingWindow from '../LoadingWindow';
import { getIndexElement } from '../../functions/searchInObject';
import { BsArrowRepeat } from "react-icons/bs";
import { AiOutlineFilter, AiOutlineStop } from "react-icons/ai";
import "../../css/general-style.css"
import "../../css/scrollBar.css"
import { Item, productLine } from './Class';

import ItemCardMin from './ItemCardMin.js';

export default class Catalogue3NoPrices extends Component {

    constructor(props) {
        super(props);
        this.searchInputRef = React.createRef();
        this.ModalLoading = React.createRef();
    }

    state = {
        Catalogo: [],
        ProductsInSearch: [],
        ProductosMostrados: [],
        ProductLine: [],
        ProductLineMostrados: [],
        oldPriceLevel: '',
        showModal: false,
        SelectedProdLine: 'All',
        currentPage: 0,
        ProductsPerPage: 60,
        TotalPages: 0,
        oldCustomerNo: '',
        selectedItem: {}
    }

    componentDidUpdate(prevProps) {
        if (prevProps.activeProducts !== this.props.activeProducts && this.props.activeProducts.length > 0) {
        this.getProductsWithProductLine(true);
        }
    }

    clearAll() {
        this.setState({
            Catalogo: [],
            ProductosMostrados: [],
            ProductLine: [],
            ProductLineMostrados: [],
            oldPriceLevel: '',
            SelectedProdLine: 'All',

        })
    }

    cleanSearchInput(){
        if (this.searchInputRef.current) {
            this.searchInputRef.current.value = '';
        }
    }

    handleModalOpen = () => {
        this.setState({ showModal: true })
    }

    handleModalClose = () => {
        this.setState({ showModal: false })
    }

    getPriceLevel() {
        if (this.props.PriceLevel) {
            this.setState({ oldPriceLevel: this.props.PriceLevel })
            return this.props.PriceLevel
        } else {
            this.setState({ oldPriceLevel: this.props.PriceLevel })
            return undefined
        }
    }



    buscarProductos = async e => {
        let search = e.target.value
        if (search.length >= 3 || search.length === 0) {
            if (this.state.SelectedProdLine !== 'All') {
                if (search !== '') {
                    let Products = this.state.Catalogo.filter((item) => {
                        if (
                            (this.contiene(item.itemCode, search) ||
                                this.contiene(item.abbreviatedDesc, search)) && (this.contiene(item.ProductLineDesc, this.state.SelectedProdLine))

                        ) {
                            return item
                        } else {
                            return null
                        }
                    })
                    await this.setState({ ProductsInSearch: Products })
                } else {
                    let Products = this.state.Catalogo.filter((item) => {
                        if (this.contiene(item.ProductLineDesc, this.state.SelectedProdLine)) {
                            return item
                        } else {
                            return null
                        }
                    })
                    await this.setState({ ProductsInSearch: Products })
                }


            } else {
                if (search !== '') {
                    let Products = this.state.Catalogo.filter((item) => {
                        if (
                            this.contiene(item.itemCode, search) ||
                            this.contiene(item.abbreviatedDesc, search)


                        ) {
                            return item
                        } else {
                            return null
                        }
                    })
                    await this.setState({ ProductsInSearch: Products })
                } else {
                    await this.setState({ ProductsInSearch: this.state.Catalogo })
                }

            }
        }
        await this.ResetPagination()



    }

    SearchLineProduct = e => {
        let search = e.target.value
        if (search !== '') {
            let ProductLines = this.state.ProductLine.filter((prodLine) => {
                if (this.contiene(prodLine.ProductLineName, search)) {
                    return prodLine
                } else {
                    return null
                }
            })

            this.setState({ ProductLineMostrados: ProductLines })
        } else {
            this.setState({ ProductLineMostrados: this.state.ProductLine })
        }

    }

    contiene(parametro, busqueda) {
        if (parametro && busqueda) {
            return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
        } else {
            return false
        }

    }
    getCustomerNo(){
        
        if(this.props.CustomerNo){
            this.setState({oldCustomerNo:this.props.CustomerNo})
        }else{
            this.setState({oldCustomerNo:''})
        }
        
    }


    async SelectProductLine(prodLine) {
        if (prodLine.ProductLineName !== 'All') {
            const catalogo = this.state.Catalogo
            let catalogoProductLine = []
            for (const item of catalogo) {

                if (item.ProductLineDesc === prodLine.ProductLineName) {
                    catalogoProductLine.push(item)
                }
            }

            await this.setState({ ProductsInSearch: catalogoProductLine, SelectedProdLine: prodLine.ProductLineName })
        } else {
            const catalogo = this.state.Catalogo
            await this.setState({ ProductsInSearch: catalogo, SelectedProdLine: 'All' })
        }
        await this.ResetPagination()
    }

    async getProductsWithProductLine(refresh) {

        if (refresh || this.state.Catalogo.length <= 0 || this.state.oldPriceLevel !== this.props.PriceLevel||this.props.CustomerNo!==this.state.oldCustomerNo) {
            await this.getCustomerNo()
            this.clearAll()
            
            const respuesta = this.props.activeProducts;
            
            let allProducts = []
            let allProductLine = []
            allProductLine.push(new productLine('All'))

            for (const item of respuesta) {
                item.ProductLineDesc=item.ProductLineDesc!=='TALPA'?item.ProductLineDesc:'TLP'
                const index1 = getIndexElement(allProductLine, 'ProductLineName', item.ProductLineDesc!=='TALPA'?item.ProductLineDesc:'TLP')
                const index2 = getIndexElement(allProducts, 'itemCode', item.itemCode)

                if (index1 === -1) {
                    allProductLine.push(new productLine(item.ProductLineDesc!=='TALPA'?item.ProductLineDesc:'TLP'))
                }
                if (index2 === -1) {
                    let description = item.completeDesc && item.completeDesc !== "null" ? item.completeDesc : item.abbreviatedDesc
                    allProducts.push(new Item(item.itemCode, description, item.upc, item.quantity, item.ShipWeight, item.StandardUnitCost, item.LastTotalUnitCost, item.UnitPrice, item.ProductLine, item.ProductLineDesc, item.upc2, item.caseupc, item.itemURLImage, 0, item.IdCompany))
                }
            }

            await this.setState({
                Catalogo: allProducts,
                ProductsInSearch: allProducts,
                ProductLine: allProductLine,
                ProductLineMostrados: allProductLine,
            })

            await this.ResetPagination()
        }

        await this.ModalLoading.current.showState(false)
    }

    async ResetPagination() {
        let totalPages = Math.round(this.state.ProductsInSearch.length / this.state.ProductsPerPage)
        let seeProds = this.state.ProductsInSearch.slice(0, 0 + this.state.ProductsPerPage)
        await this.setState({
            ProductosMostrados: seeProds,
            currentPage: 0,
            ProductsPerPage: 60,
            TotalPages: totalPages
        })
        await this.updateInputsCard()
    }

    async nextPage() {
        if ((this.state.currentPage + this.state.ProductsPerPage) <= this.state.ProductsInSearch.length) {
            await this.setState({ currentPage: this.state.currentPage + this.state.ProductsPerPage })
        }
        this.updateSeeProducts()
        this.backToTop()
    }

    async prevPage() {
        if (this.state.currentPage > 0) {
            await this.setState({ currentPage: this.state.currentPage - this.state.ProductsPerPage })
        }
        this.updateSeeProducts()
        this.backToTop()
    }

    async updateSeeProducts() {
        let seeProds = this.state.ProductsInSearch.slice(this.state.currentPage, this.state.currentPage + this.state.ProductsPerPage)


        await this.setState({
            ProductosMostrados: seeProds,
        })
        await this.updateInputsCard()
    }

    updateInputsCard() {
        for (const item of this.state.ProductosMostrados) {
            if (document.getElementById('QuantityAdded_' + item.itemCode)) {
                document.getElementById('QuantityAdded_' + item.itemCode).value = item.InputValue
            }
        }
    }

    backToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    selectItem(item){
        const newProduct = { itemCode: item.itemCode, abbreviatedDesc: item.abbreviatedDesc, itemURLImage: item.itemURLImage, pendingProcess: true,  InactiveItem: 'Y' };
        const { Padre } = this.props;
        const inactiveProducts =  Padre.state.inactiveProducts;
        const selectedActiveProducts = Padre.state.selectedActiveProducts;

        const alreadyExists = inactiveProducts.some(
            p => p.itemCode === newProduct.itemCode
        );

        if (alreadyExists) {
            // Remove it
            Padre.setState({
                inactiveProducts: inactiveProducts.filter(p => p.itemCode !== item.itemCode),
                selectedActiveProducts: selectedActiveProducts.filter(p => p.itemCode !== item.itemCode),
            });
        } else {
            // Append it
            Padre.setState(prevState => ({
                inactiveProducts: [newProduct, ...prevState.inactiveProducts],
                selectedActiveProducts: [item, ...prevState.selectedActiveProducts]
            }));
        }
    }

    setInactiveProduct = () => {
        this.props.setAsInactive();
        const activeProducts = this.props.activeProducts;
        const selectedProducts = this.props.Padre.state.selectedActiveProducts;
        const newActiveProductIds = new Set(selectedProducts.map(p => p.itemCode));
        const filteredActiveProducts = activeProducts.filter(p => !newActiveProductIds.has(p.itemCode));
        this.props.updateProductStatus(filteredActiveProducts)
    }



    render() {
        return (
            <React.Fragment>
                <LoadingWindow ref={this.ModalLoading} />
                    <div className='row'>
                        <div className="offcanvas offcanvas-start" tabIndex="-1" id="canvasCategoryCatalog3NoPrices" aria-labelledby="canvasCategorysDet">
                            <div className="offcanvas-header">
                                <h5 className="offcanvas-title" id="offcanvasExampleLabel">Product Lines</h5>
                                <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                            </div>
                            <div className="offcanvas-body row">
                                <div className='col-sm-12 FixedTitle'>
                                    <div className='row'>
                                        <div className='InputTextBolder PrincipalHead col-sm-12 text-center '>
                                            <div className="input-group flex-nowrap">
                                                <input className='form-control w-75 display-inline' placeholder='Search by Product Line...' id={'productLineSearch' + this.props.nombrePadre} onKeyUp={this.SearchLineProduct} autoComplete={"off"} ref={this.searchInputRef}/>
                                                <span className="input-group-addon">
                                                    <button className='btn greenButton' onClick={() => this.getProductsWithProductLine(true)}><BsArrowRepeat /></button>
                                                </span>
                                            </div>
                                        </div>
                                        {this.state.ProductLineMostrados.map((element, pL) => (
                                            <div data-bs-dismiss="offcanvas" key={pL} onClick={() => this.SelectProductLine(element)} className={'col-sm-12 InputTextBolder2 ' + (element.ProductLineName === this.state.SelectedProdLine ? 'backgroundSky2' : '')}>
                                                <p>{element.ProductLineName}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 FixedTitle2'>
                            <div className='row'>
                                <div className='col-12 PrincipalHead2 mb-4' style={{ backgroundColor: '#fff' }}>
                                    <div className='d-flex align-items-center justify-content-between mb-4'>
                                        <h5 className='darkPurpleText mb-0 d-flex align-items-center'>
                                            Active Products 
                                            {/* Selected badge */}
                                            {this.props.Padre.state.selectedActiveProducts.length > 0 && (
                                                <span className="badge badgeRedBg ms-2">
                                                    {this.props.Padre.state.selectedActiveProducts.length}
                                                </span>
                                            )}
                                        </h5>
                                        
                                        {/* Save button */}
                                        {this.props.Padre.state.selectedActiveProducts.length > 0 && (
                                            <button type="button" className="btn btn-sm orangeButton d-flex align-items-center" onClick={this.setInactiveProduct}>
                                                <AiOutlineStop title="Desactivar" size={20} className='me-2' />
                                                Deactivate
                                            </button>
                                        )}
                                    </div>

                                    <div className="input-group flex-nowrap mb-4">
                                        <button className="btn blueButton" type="button" data-bs-toggle="offcanvas" data-bs-target="#canvasCategoryCatalog3NoPrices" aria-controls="canvasCategorys">
                                            <AiOutlineFilter title="Filtrar" size={20} /> 
                                        </button>

                                        <input className='form-control w-75 inputResize' placeholder='Search by item code or  description' id={'catalogo_busqueda' + this.props.nombrePadre} onKeyUp={this.buscarProductos} autoComplete={"off"} />
                                    </div>
                                </div>
                                
                                <br />

                                {
                                    this.state.ProductosMostrados.map((producto, i) => (
                                        <div key={i} className='col-sm-6 col-md-4 my-2' onClick={() => this.selectItem(producto)}>
                                            <ItemCardMin State={this.props.State} PriceLevel={this.props.PriceLevel} Padre={this.props.Padre} Array={this.props.Array} nombrePadre={this.props.nombrePadre} objectProd={producto} itemURLImage={producto.itemURLImage} ItemCode={producto.itemCode} Description={producto.abbreviatedDesc} />
                                        </div>
                                    ))
                                }
                            </div>
                            {/* <div className='row'>
                                <div className='col-sm-12 text-center'>
                                    <div className="btn-group btn-group-lg pt-4" role="group" aria-label="pagination">
                                        <button type="button" onClick={() => this.prevPage()} className="btn blueButton">Prev</button>
                                        <button type="button" onClick={() => this.nextPage()} className="btn blueButton">Next</button>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                
            </React.Fragment>
        )
    }
}